import React, { useEffect, useState, useRef } from "react";
import { SubNavItem, ListItem, UL, Div } from "./styles";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import { getItemHighlightTemplate } from "../setting/HighlightConstants.js";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt/index.js";
import { setGetStarted } from "../../StateManagement/Reducers/GetStartedState.js";

const ScheduleNav = ({ showStepFourIntro, setShowStepFourIntro }) => {
  //------------------------------------------State and Variables Start------------------------------------------//
  const [proavailabilty1, setproavailabilty1] = useState(false);
  const ProvHighlightRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");

  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const setprovabailityNext2 = () => {
    setproavailabilty1(false);
    history.push("/schedule/apptemplate", { showProvPopup: true });
  };

  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  const handleIntroNext = () => {
    dispatch(setGetStarted({ fromComponent: true }));
    setShowStepFourIntro(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=6.5",
    });
  };

  const handleIntroBack = () => {
    setShowStepFourIntro(false);
    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.3",
    });
  };
  // ------------------------------- Functions End--------------------------------------------------------- //

  useEffect(() => {
    const handleTrigger = () => {
      setproavailabilty1(true);
    };

    window.addEventListener("triggerProviderPopup", handleTrigger);

    return () => {
      window.removeEventListener("triggerProviderPopup", handleTrigger);
    };
  }, []);

  useEffect(() => {
    if (location.state?.Provstarted) {
      setproavailabilty1(true);
      history.replace(location.pathname, {});
    }
  }, [location.state]);
  // ------------------------------- UseEffect End ------------------------------------------------------- //

  return (
    <Div width="100%" paddingLeft="0.86em">
      <UL
        textAlign="left"
        width="100%"
        listStyleType="none"
        padding="0"
        margin="0"
        position="relative"
      >
        <ListItem
          padding="8px"
          margin="8px 0 0 0"
          onClick={handleInputChange("iconopen")}
        >
          <Popup
            offset={[50, 20]}
            content={
              <GetStartedPopup
                title="Scheduling Appointment"
                description={
                  <div>
                    <div>
                      Go to Schedule {">"} Calendar menu to schedule different
                      appointment types like Telehealth & Walk-in to all
                      patients.
                    </div>{" "}
                    <br></br>
                    <div>
                      Further steps includes adding vitals, services, billing &
                      clinical notes.
                    </div>
                  </div>
                }
                currentStep={4}
                totalSteps={6}
                onNext={handleIntroNext}
                onBack={handleIntroBack}
                onClose={() => setShowStepFourIntro(false)}
                width="320px"
              />
            }
            open={showStepFourIntro}
            className="m-t-10"
            trigger={
              <SubNavItem
                to="/schedule/calender"
                exact
                className={`${
                  (splitLocation[1] === "schedule" &&
                    splitLocation[2] === "nav") ||
                  splitLocation[2] === "calender" ||
                  location.pathname === "/"
                    ? "active"
                    : ""
                } ${!showStepFourIntro ? "" : "highlight"}`}
              >
                Calendar
              </SubNavItem>
            }
            position="left center"
          />
          {showStepFourIntro && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 10,
              }}
              onClick={() => setShowStepFourIntro(false)}
            />
          )}
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/appdashboard" exact>
            Appointment Dashboard
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/practicedashboard" exact>
            Practice Dashboard
          </SubNavItem>
        </ListItem>

        <Div
          ref={ProvHighlightRef}
          style={
            decryptedPermission.setProviderAvailability
              ? getItemHighlightTemplate(proavailabilty1)
              : {}
          }
        >
          <ListItem
            padding="8px"
            margin="0"
            onClick={handleInputChange("iconopen")}
          >
            {decryptedPermission.setProviderAvailability ? (
              <Popup
                offset={[40, 45]}
                content={
                  <GetStartedPopup
                    title="Setting Provider Availability"
                    description={
                      <div>
                        <div>
                          Go to Schedule {">"} Provider Availability menu to set
                          provider’s availability based on the different
                          categories.
                        </div>
                      </div>
                    }
                    currentStep={1}
                    totalSteps={6}
                    onNext={() => setprovabailityNext2()}
                    onClose={() => setproavailabilty1(false)}
                    width="320px"
                  />
                }
                open={proavailabilty1}
                className="m-t-10"
                trigger={
                  <SubNavItem to="/schedule/apptemplate" exact>
                    Provider Availability
                  </SubNavItem>
                }
                position="left center"
              />
            ) : (
              <SubNavItem to="/schedule/apptemplate" exact>
                Provider Availability
              </SubNavItem>
            )}
          </ListItem>
        </Div>
        {decryptedPermission.setProviderAvailability && proavailabilty1 && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 10,
            }}
            onClick={() => setproavailabilty1(false)}
          />
        )}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/billingprofiles" exact>
            Billing Profiles
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/appprofiles" exact>
            Appointment Profiles
          </SubNavItem>
        </ListItem>

        {/* {(owner_id === null || owner_id === " ") && ( */}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/auditlog" exact>
            Audit Log
          </SubNavItem>
        </ListItem>
        {/* )} */}
      </UL>
    </Div>
  );
};

export default ScheduleNav;
